// Global Instructions Rule Applied!
//
// The help "?" for a label that is not an InputManager field - a table
// column header, a stat tile. Same glyph, tooltip width and placement as
// the field-label help (InputManager `labelTooltip` ->
// FieldLabelContent), so a "?" reads the same wherever it appears. Renders
// nothing when there is nothing to say, so callers drop it in
// unconditionally.
//
// Like the field-label "?", it is for something the user is not expected to
// know (which call lines a fund's terms leave out of % Drawn), not for
// restating the label.
//
// `maxWidth` and `placement` are for an explanation that runs to several
// options with a worked example each (the Waterfall section's Earlier
// distributions select): wider, so it does not grow tall, and beside the
// icon ('right'), where antd slides it up or down to stay inside the window
// - above the icon ('topLeft', the default) a tall tooltip is cut off.

import React from 'react'
import { Tooltip, theme } from 'antd'
import type { TooltipProps } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface HelpTipProps {
  title?: React.ReactNode
  maxWidth?: number
  placement?: TooltipProps['placement']
}

export default function HelpTip({ title, maxWidth = 460, placement = 'topLeft' }: HelpTipProps): React.ReactElement | null {
  const { token } = theme.useToken()
  if (!title) return null
  return (
    <Tooltip title={title} styles={{ root: { maxWidth } }} placement={placement}>
      <QuestionCircleOutlined
        aria-label='Help'
        className='ml-1 cursor-help align-middle'
        style={{ color: token.colorPrimary }}
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  )
}
